export default class ApiAccessKey {

  constructor( api, id ) {
    this.api = api.child( id )
  }

  /**
   * Get api access key.
   */
  get( opts ) {
    return this.api.get( opts )
  }

  /**
   * Update api access key.
   */
  update( update, options ) {
    return this.api.patch( update, options )
  }

  /**
   * Delete api access key
   */
  delete( opts ) {
    return this.api.delete( null, opts )
  }
}
